import React, { useState, useMemo } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

// Contexts
import { ColorModeContext } from 'contexts/ColorModeContext';

// Styles
import { theme as customTheme } from 'styles/theme';

function AppThemeProvider({ children }) {
  // default to light mode
  const [mode, setMode] = useState('light');

  // Theme color
  const colorMode = useMemo(
    () => ({
      // methods used to lookup and change mode
      colorMode: () => mode,
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      }
    }),
    [mode]
  );

  return (
    <StyledEngineProvider injectFirst>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={customTheme[mode]}>
          {children}
        </ThemeProvider>
      </ColorModeContext.Provider>
    </StyledEngineProvider>
  )
}

export { AppThemeProvider }